import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { getUserLocal } from '@shared/types/local-settings';
import { catchError, first, delay, mergeMap, skipWhile } from 'rxjs/operators';
import { RefreshTokenService } from '@service/rest/refresh-token/refresh-token.service';
import { LogoutService } from '@service/rest/login/logout.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private refreshTokenService: RefreshTokenService,
    private logoutService: LogoutService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenRenewing = this.refreshTokenService.isTokenRenewing();
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === undefined || err.status === 401) {
          // token yenilerken 401 alırsa direk dışarı
          if (request.url.split('/').pop() === 'refresh') {
            this.logoutService.clearAfterLogout();
            return throwError(err);
          } else {
            const currentToken = getUserLocal('token');
            // token yenileniyorsa yada şuanki token request yapılan tokene eşit değilse; request 401 alana kadar refresh token çalışıp bitmiş olabilir
            if (tokenRenewing || `Bearer ${currentToken}` !== request.headers.get('Authorization')) {
              return this.retrySameRequest(request, next);
            } else {
              this.logoutService.clearAfterLogout();
            }
          }
        } else {
          return throwError(err);
        }
      })
    );
  }

  private retrySameRequest(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return from(this.refreshTokenService.isTokenRenewingPromise()).pipe(skipWhile(f => !f), delay(1200), first(),
      mergeMap((res) => {
        const token = getUserLocal('token');
        const req = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
          },
        });

        return next.handle(req).pipe(
          catchError(er => {
            if (er.status === undefined || er.status === 401) {
              this.logoutService.clearAfterLogout();
            } else {
              return throwError(er);
            }
          })
        );
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }
}
